import http from '@/communication/AuthConnection'
import moment from 'moment'

const sanitizeForm = (pForm) => {
  const retForm = { ...pForm }
  const dateCreated = moment(pForm.proposalInfo.dateCreated, 'DD/MM/YYYY').format('YYYY-MM-DD')
  retForm.proposalInfo.dateCreated = dateCreated
  return JSON.stringify(retForm)
}

/**
* Read the file dropped
*/
const readFile = (pFile, pForm) => {
  const formData = new FormData()
  const proposalInfo = sanitizeForm(pForm)

  formData.append('fileXLSX', pFile)
  formData.append('form', proposalInfo)

  return http.post('/v1/event-detail/generate-proposal-by-xlsx', formData, {
    responseType: 'blob',
    headers: {
      'Content-type': 'multipart/form-data'
    }
  })
  .then(pData => pData.data)
}

export default readFile



// WEBPACK FOOTER //
// ./src/brain/event-detail/GenerateProposal.js